import {Box, Divider, IconButton, InputLabel, Stack, Typography} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {Add, Remove} from '@icons/index';
import {Sizes} from '@constants/sizes.constants';
import SelectComponent from '@components/inputs/select/Select.component';
import TimeTextFieldComponent from '@components/inputs/timePicker/TimeTextFieldComponent';
import TextFieldComponent from '@components/inputs/textField/TextField.component';

const AvailabilityRulesForm = () => {

  const {t} = useTranslation();

  const items = [];

  return (
    <>
      <Stack py="20px" spacing={2}>
        <Typography fontSize={16} fontWeight="700">
          {t('operations.executions.manage.availabilityRules')}
        </Typography>
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <InputLabel sx={{width: Sizes.drawerInputLabelWidth}}>
              {t('operations.executions.manage.days')}
            </InputLabel>
            <Stack direction="row" alignItems="center">
              <IconButton>
                <Remove/>
              </IconButton>
              <Typography fontSize={16} fontWeight="400">
                {/*{execution?.quantity || 0}*/}
              </Typography>
              <IconButton>
                <Add/>
              </IconButton>
            </Stack>
          </Stack>
          <SelectComponent
            color="secondary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('operations.executions.manage.dayTime')}
            // value={execution?.container}
            items={items?.map((w) => ({label: w, value: w}))}
            readOnly/>
          <Stack direction="row" justifyContent="space-between" spacing={2}>
            <InputLabel sx={{width: Sizes.drawerInputLabelWidth}}>
              {t('operations.executions.manage.date')}
            </InputLabel>
            <Box flex={0.5}>
              <TimeTextFieldComponent
                color="secondary"
                label={t('global.dateFrom')}
                readOnly/>
            </Box>
            <Box flex={0.5}>
              <TimeTextFieldComponent
                color="secondary"
                label={t('global.dateTo')}
                readOnly/>
            </Box>
          </Stack>
          <SelectComponent
            color="secondary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('operations.executions.manage.frequency')}
            // value={execution?.container}
            items={items?.map((w) => ({label: w, value: w}))}
            readOnly/>
          <TextFieldComponent
            color="secondary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('operations.executions.manage.zone')}
            // value={execution?.container}
            readOnly/>
          <TextFieldComponent
            color="secondary"
            labelWidth={Sizes.drawerInputLabelWidth}
            label={t('operations.executions.manage.theoreticalQuantity')}
            // value={execution?.container}
            readOnly/>
        </Stack>
      </Stack>
      <Divider variant="fullWidth" orientation="horizontal"/>
    </>
  );
};

export default AvailabilityRulesForm;
